import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { NoDataCard } from 'legacyComponents/cards/types/noData';
import { Tab } from 'legacyComponents/styled/lib';
import { ContributionCard } from 'legacyComponents/cards/types/contribution';
import { CardSection } from 'legacyComponents/layout/cardSection';

import { ContributionConnManager } from 'apps/repository/connManager';

@observer
export class ActivityLogTab extends React.Component {
  UNSAFE_componentWillMount() {
    const { project } = this.props;
    this.contributionsConn = new ContributionConnManager(null, {
      projectId: project.id,
    });
    this.contributionsConn.loadMore();
  }

  render() {
    const { project } = this.props;
    const contributions = this.contributionsConn.arrayApp;

    if (
      !this.contributionsConn.loading &&
      this.contributionsConn.totalCount === 0
    ) {
      return (
        <NoDataCard
          type='contributions'
          owner={project.inSpace.whichTypes.includes('Contribution')}
        />
      );
    }

    return (
      <div>
        <Tab noShadow>
          <CardSection
            title=''
            cardApp={contributions}
            CardComponent={ContributionCard}
            noMarginTop
            activityLogTab
          />
        </Tab>
      </div>
    );
  }
}

ActivityLogTab.propTypes = {
  app: PropTypes.object,
  project: PropTypes.object,
  manager: PropTypes.object,
};
